import {QuotePDFBuilder} from "./QuotePDFBuilder";
import {PriceLine, PriceRider} from "../../../../../api/Pricing";
import {PriceSectionNote} from "../../../../../api/PriceSectionNotes";
import {QuotePriceLine, QuotePriceRider} from "../../../../../api/QuotePricing";

// The glazing section of the quote PDF. Glass carries no preps, so unlike the door and frame
// sections this is one flat category plus its riders.
export function addGlazingSection(bld: QuotePDFBuilder, props: {
    riders: (QuotePriceRider | PriceRider)[];
    prices: (PriceLine | QuotePriceLine)[];
    notes: PriceSectionNote[];
}) {
    const isOurs = (i: PriceLine | QuotePriceLine) => i.productType === "glazing";
    const isOurRider = (r) => r.productType === "glazing";

    const riders = props.riders.filter(isOurRider);

    bld.addSection(
        {
            title: "Glazing",
            note: props.notes.filter(n => n.keyName === "glazing").map(v => v.note),
            categories: [
                {
                    name: "Glazing",
                    filter: isOurs,
                    filterRider: isOurRider,
                    adminExcludeRiders: true,
                }, !bld.excludeRiders && {
                    name: "Glazing Riders",
                    filter: () => false,
                    filterRider: isOurRider,
                }
            ],
        },
        (props.prices as PriceLine[]).filter(isOurs),
        riders,
    )
}
